import type { SVGProps } from 'react';
import * as React from 'react';

const SvgRefreshCcw01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 10s2.005-2.732 3.634-4.362A9 9 0 1 1 12 21a9.004 9.004 0 0 1-8.648-6.5M2 10V4m0 6h6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgRefreshCcw01;
